import * as React from 'react'
import Icon from 'components/common/icons/customIcon'
import { useTranslation } from 'react-i18next'

export type IProps = {
  messageKey: string
  options?: { [key: string]: string | number | boolean }
  iconName?: string
  errorStatus?: number
  link?: string
  children?: React.ReactNode
}

const LogCardMessage = ({ messageKey, options, children, iconName, errorStatus, link }: IProps) => {
  const { t } = useTranslation()
  return (
    <div className="mg-dashboard-content-no-filter">
      <div className="log-card-message">
        <div className="no-user-preferences-filter-error__container__error-message">
          {iconName ? <Icon name={iconName} /> : <span className="material-icons">info</span>}
          <div className="mg-typo-title-6">
            {errorStatus > 0 && <span>({errorStatus})&nbsp;</span>}
            {t(messageKey, options)}
          </div>
          {children}
          {link && (
            <div>
              <a className="link-log" href={link} title="" target="_blank" rel="noopener noreferrer">
                {link}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default LogCardMessage
